var ns;
ns.App.factory('UnitAutoWorkService', function(
  HttpFactory, API_ENDPOINT, DsFactory, Utils
  ){
  return {
    getUnitAutoWorkLogs: function(sid, dsConf, params) {
      var endpoint = API_ENDPOINT + '/unit_auto_work_logs?screen_id=' + sid;
      if(!angular.isUndefined(params)){
        endpoint += "&" + Utils.getQueryStr(params);
      }
      return DsFactory.create(dsConf, endpoint);
    },
    getUnitAutoWorks: function (sid) {
      var endpoint = API_ENDPOINT + '/unit_auto_work_get?screen_id=' + sid;
      return HttpFactory.createGet(endpoint);
    },
    getUnitAutoWorkTimes: function (sid) {
      var endpoint = API_ENDPOINT + '/unit_auto_work_time_get?screen_id=' + sid;
      return HttpFactory.createGet(endpoint);
    },
    getUnitAutoWorkReports: function (sid) {
      var endpoint = API_ENDPOINT + '/unit_auto_work_report_get?screen_id=' + sid;
      return HttpFactory.createGet(endpoint);
    },
    upsertUnitAutoWorkSettings: function (params) {
      var endpoint = API_ENDPOINT + '/unit_auto_work_edits';
      return HttpFactory.createPost(endpoint, params);
    },
    checkUnitAutoWork: function () {
      var endpoint = API_ENDPOINT + '/unit_auto_work_report_check/';
      return HttpFactory.createGet(endpoint);
    },
    getZip: function (id) {
      return API_ENDPOINT + '/unit_auto_work_logs_download/' + id;
    },
    manualExecution: function () {
      var endpoint = API_ENDPOINT + '/unit_auto_work_manual/';
      HttpFactory.createGet(endpoint);
    },
    stateSwitching: function (params) {
      var endpoint = API_ENDPOINT + '/unit_auto_work_state_switching';
      return HttpFactory.createPost(endpoint, params);
    }
  };
});
